import clsx, { type ClassValue } from 'clsx';

/** รวม class name โดยตัดค่า falsy ออก */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}
